var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"animation"}},[(_vm.showLoading)?_c('div',{staticClass:"loadindWrap",style:({ background: _vm.backgroundColor })},[_c('div',{staticClass:"loadingContent"},[_c('div',{staticClass:"iBox"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }